import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import Loader from "../../shared/Loader";
import {
  useCreateSavedIban,
  useUpdateSavedIban,
} from "../../lib/queries/queriesAndMutations";
import { toast } from "react-toastify";
import IbanInput from "../../shared/IbanInput";
import CustomPaymentInput from "../../ui/payment/CustomPaymentInput";
import { IbanNoteSchema } from "../../lib/validation";
import { useQueryClient } from "@tanstack/react-query";

export default function SavedIbanForm({ close, formType, data, refetch }) {
  const queryClient = useQueryClient();
  const processedData = {
    ...data,
    iban: data?.iban.startsWith("IR") ? data?.iban.slice(2) : data?.iban,
  };

  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    values:
      formType === "create"
        ? {
            iban: "",
            iban_nickname: "",
          }
        : processedData,
    resolver: zodResolver(IbanNoteSchema),
  });

  const { mutateAsync: createNewSavedIban, isPending: isPendingCreating } =
    useCreateSavedIban();
  const { mutateAsync: updateNewSavedIban, isPending: isPendingUpdating } =
    useUpdateSavedIban();

  const processForm = async (data) => {
    try {
      const res =
        formType === "create"
          ? await createNewSavedIban(data)
          : await updateNewSavedIban({ data: data, id: processedData?.id });

      console.log({ res });
      if (res?.status === 200 || res?.status === 201) {
        queryClient.invalidateQueries({ queryKey: ["getDestinationIbans"] });
        toast.success("با موفقیت ثبت شد");
        // refetchDestinations();
        reset();
        close(); // close popup after success
        refetch(); // close popup after success
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data) => processForm(data))}
      className="w-full bg-white mb-5 rounded-v-lg p-2 flex flex-col gap-2  max-h-[90vh] mx-auto overflow-y-auto"
      dir="rtl"
    >
      <CustomPaymentInput
        register={register}
        control={control}
        name="iban_nickname"
        label="نام مستعار (اختیاری)"
        type="text"
        errors={errors.iban_nickname}
      />

      <IbanInput
        control={control}
        name="iban"
        value={watch("iban")}
        label="شماره شبا"
        placeholder="●●●● ●●●● ●●●●  ●●●● ●●●● ●●●● "
        type="text"
        errors={errors.iban}
        isSheba
      />

      <button
        type="submit"
        className="bg-dark text-white p-2 rounded-md"
        disabled={isPendingCreating || isPendingUpdating}
      >
        {isPendingUpdating || isPendingCreating ? (
          <div className="flex gap-1 items-center">
            <div className="w-6 h-6">
              <Loader />
            </div>
            در حال ثبت...
          </div>
        ) : formType === "create" ? (
          "افزودن حساب"
        ) : (
          "ویرایش حساب"
        )}
      </button>
    </form>
  );
}
